export const appConfig = {
	pageDefault: "why-bitsinmotion"
}
